export default __webpack_public_path__ + "static/media/typeS_low.9b28fc97.png";